module.exports = __webpack_public_path__ + "img/合作交流标题.e8944c75.png";